import React, { useState } from "react";
import Input from "../../../components/FormComponents/Input";
import Textarea from "../../../components/FormComponents/Textarea";
import Button from "../../../components/FormComponents/Button";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import { toastError, toastSuccess } from "../../../utils/toastUtils";

const MongoFieldsTable = ({ fields = [], onChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [name, setName] = useState("");
  const [type, setType] = useState("");

  const handleAdd = () => {
    if (!name.trim() || !type.trim()) {
      toastError("Enter both Name and Type.");
      return;
    }

    const isDuplicate = fields.some((item) => item.name === name.trim());
    if (isDuplicate) {
      toastError("Name already exists");
      return;
    }

    const newField = { name: name.trim(), type: type.trim(), index: null };
    onChange([...fields, newField]);
    setName("");
    setType("");
  };

  const handleDelete = (index) => {
    const updated = fields.filter((_, i) => i !== index);
    onChange(updated);
  };

  const handleUpdate = (index, updatedField) => {
    const updated = [...fields];
    updated[index] = updatedField;
    onChange(updated);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(fields, null, 2));
    toastSuccess("Copied to clipboard!");
  };

  return (
    <div style={{ marginTop: "20px" }} className="builder_form">
      <div className="d_flex space_between align_center mb_2">
        <label className="builder_label">Fields</label>
        <div className="d_flex gap_2">
          <ButtonActionIcon type="upload" onClick={() => setIsModalOpen(true)} />
          <ButtonActionIcon type="content_copy" onClick={handleCopy} />
        </div>
      </div>

      <div className="d_flex gap_2 align_center">
        <Input placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
        <Input placeholder="Type" value={type} onChange={(e) => setType(e.target.value)} />
        <MaterialIcon name="add" className="builder_action_btn add" onClick={handleAdd} />
      </div>

      {Array.isArray(fields) && fields.length > 0 ? (
        <table className="table mt_3">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {fields.map((item, index) => (
              <MongoFieldRow key={index} item={item} index={index} onDelete={handleDelete} onUpdate={handleUpdate} />
            ))}
          </tbody>
        </table>
      ) : (
        <p className="mt_3">No fields added.</p>
      )}

      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName="Upload Fields JSON">
        <UploadFieldsJson
          onUpload={(parsed) => {
            onChange(parsed);
            setIsModalOpen(false);
          }}
        />
      </BuilderModal>
    </div>
  );
};

const MongoFieldRow = ({ item, index, onDelete, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editName, setEditName] = useState(item.name);
  const [editType, setEditType] = useState(item.type);

  const handleSave = () => {
    if (!editName.trim() || !editType.trim()) {
      toastError("Name and Type required.");
      return;
    }

    onUpdate(index, { name: editName.trim(), type: editType.trim(), index: item.index || null });
    setIsEditing(false);
  };

  return (
    <tr>
      <td>{isEditing ? <Input value={editName} onChange={(e) => setEditName(e.target.value)} /> : item.name}</td>
      <td>{isEditing ? <Input value={editType} onChange={(e) => setEditType(e.target.value)} /> : item.type}</td>
      <td className="d_flex gap_1">
        {isEditing ? (
          <MaterialIcon name="save" className="builder_action_btn save" onClick={handleSave} />
        ) : (
          <>
            <MaterialIcon name="edit" className="builder_action_btn edit" onClick={() => setIsEditing(true)} />
            <MaterialIcon name="delete" className="builder_action_btn delete" onClick={() => onDelete(index)} />
          </>
        )}
      </td>
    </tr>
  );
};

const UploadFieldsJson = ({ onUpload }) => {
  const [jsonValue, setJsonValue] = useState("");

  const handleUpload = () => {
    try {
      const parsed = JSON.parse(jsonValue);
      if (!Array.isArray(parsed)) throw new Error();
      onUpload(parsed);
    } catch {
      toastError("Invalid JSON format");
    }
  };

  return (
    <div className="builder_form">
      <Textarea value={jsonValue} onChange={(e) => setJsonValue(e.target.value)} />
      <Button onClick={handleUpload}>Upload</Button>
    </div>
  );
};

export default MongoFieldsTable;
